import React from 'react';
import { Layout } from '../components/Layout';
import { Hero } from '../components/Hero';
import { PromoSection } from '../components/PromoSection';
import { Categories } from '../components/Categories';
import { ValueProps } from '../components/ValueProps';
import { About } from '../components/About';
export function Home() {
  return <Layout data-id="element-178">
      <Hero data-id="element-179" />
      <PromoSection data-id="element-180" />
      <Categories data-id="element-181" />
      <ValueProps data-id="element-182" />
      <About data-id="element-183" />
    </Layout>;
}